import { useState } from "react";
import { Printer } from "lucide-react";
import { PLANTILLAS, FORMATOS } from "@/lib/carteles";
import { Cartel, PX_MM } from "@/components/carteles/CartelPlantilla";

// Carteles para las vallas de una zona de estacionamiento prohibido, ya rellenos con su horario y el evento:
// desde una hora, franja de un día y varios días; en A4 o A3, con la señal R-307 o sin ella.
const TIPOS = ["vallas", "vallas_franja", "vallas_dias"];
const ANCHO = 260; // px de la vista previa en el panel

export const CartelesZona = ({ ev, el, timing }) => {
  const [formato, setFormato] = useState("A4");
  const [senal, setSenal] = useState(true);
  if (!ev?.id) return null;
  // el horario escrito en la zona manda; si no lo hay, el que calcula el plan; si tampoco, el del evento
  const hora = el.start_time || timing?.start_hm || ev.start_time || "";
  const hasta = el.end_time || timing?.end_hm || ev.end_time || "";
  const datos = { hora, hora_hasta: hasta, fecha: ev.date || "", fecha_hasta: ev.date || "", motivo: ev.name || "", dias: "", senal };
  const f = FORMATOS[formato];
  const escala = ANCHO / (f.w * PX_MM);
  const abrir = (tpl) => {
    const q = new URLSearchParams({ tpl, formato, senal: senal ? "1" : "0", hora, hora_hasta: hasta, fecha: datos.fecha, fecha_hasta: datos.fecha_hasta, motivo: datos.motivo });
    window.open(`/events/${ev.id}/carteles?${q}`, "_blank", "noopener");
  };
  return (
    <div className="space-y-2" data-testid="zone-posters">
      <div className="text-xs font-semibold text-slate-700">Carteles para las vallas</div>
      <div className="flex gap-1.5">
        {Object.keys(FORMATOS).map((k) => (
          <button key={k} type="button" onClick={() => setFormato(k)} data-testid={`zone-poster-format-${k}`}
            className={`h-8 px-3 rounded-md border text-xs font-semibold ${formato === k ? "border-sky-500 bg-sky-600 text-white" : "border-slate-300 text-slate-700 hover:bg-slate-50"}`}>{k}</button>
        ))}
        <label className="ml-auto flex items-center gap-1.5 text-xs text-slate-700 cursor-pointer">
          <input type="checkbox" checked={senal} onChange={(e) => setSenal(e.target.checked)} className="w-4 h-4 accent-sky-600" data-testid="zone-poster-senal" /> Señal R-307
        </label>
      </div>
      {TIPOS.map((id) => {
        const tpl = PLANTILLAS.find((t) => t.id === id);
        return (
          <div key={id} className="rounded-lg border border-slate-200 bg-slate-50 p-2 space-y-1.5" data-testid={`zone-poster-${id}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-medium text-slate-800">{tpl.nombre}</span>
              <button type="button" onClick={() => abrir(id)} className="flex items-center gap-1 text-xs font-semibold text-sky-700 hover:underline" data-testid={`zone-poster-open-${id}`}>
                <Printer className="w-3.5 h-3.5" /> Abrir {formato}
              </button>
            </div>
            <div className="overflow-hidden rounded border border-slate-300 bg-white pointer-events-none" style={{ width: ANCHO, height: f.h * PX_MM * escala }}>
              <div style={{ transform: `scale(${escala})`, transformOrigin: "top left" }}>
                <Cartel tpl={tpl} datos={datos} formato={formato} ine={ev.concello} />
              </div>
            </div>
          </div>
        );
      })}
      <p className="text-[0.625rem] text-slate-500 leading-snug">Rellenos con el horario de la zona ({hora || "—"}–{hasta || "—"}) y el evento. Al abrirlos puede cambiar los datos antes de imprimir.</p>
    </div>
  );
};
